import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var InfoCircleTwoTone = function InfoCircleTwoTone(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10.5",
    fill: "#37A9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.074 5.5c0.94797 0 1.2265 0.61333 1.2265 1.3148 0 0.87538-0.62793 1.6852-1.7005 1.6852-0.89733 0-1.3247-0.50264-1.2984-1.3351 0-0.70143 0.52564-1.6649 1.7724-1.6649zm-3.3884 10.829l0.79115-3.1359c0.13708-0.50175 0.15974-0.70286 0-0.70286-0.20615 0-1.1031 0.34625-1.6319 0.68835l-0.34431-0.54218c1.6784-1.3466 3.6082-2.1366 4.4339-2.1366 0.69077 0 0.80518 0.78372 0.46087 1.9904l-0.90664 3.2966c-0.16082 0.58261-0.091743 0.78372 0.069077 0.78372 0.20723 0 0.88505-0.24051 1.5521-0.74537l0.39072 0.50382c-1.633 1.5674-3.4128 2.1708-4.1025 2.1708-0.69077 0-1.1948-0.40327-0.71236-2.1708z",
    fill: "#fff"
  })));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
export default InfoCircleTwoTone;